import { ISelctedSeat } from "@/redux/rent/types";
import dateFormat from "dateformat";

export interface BasketItem {
  startTime: string; // ISO string
  finishTime: string; // ISO string
  courtId: string;
}

export function validateAndPrepareBasketItems(
  basketTemp: { [key: string]: ISelctedSeat }
): BasketItem[] {
  const result: BasketItem[] = [];

  if (!basketTemp || typeof basketTemp !== 'object') {
    console.warn('Invalid basketTemp object');
    return result;
  }

  Object.keys(basketTemp).forEach((key) => {
    const seat = basketTemp[key];

    if (!seat.date || !seat.time || !seat.bitrixCourtId) {
      console.warn(`Missing required fields for seat ${key}:`, seat);
      return;
    }

    try {
      const dateStr = seat.date;
      const timeStr = seat.time;
      
      const [hours, minutes] = timeStr.split(':').map(Number);
      const startDate = new Date(dateStr);
      startDate.setHours(hours, minutes, 0, 0);
      
      if (isNaN(startDate.getTime())) {
        console.warn(`Invalid date/time for seat ${key}:`, { dateStr, timeStr });
        return;
      }

      const finishDate = new Date(startDate);
      finishDate.setMinutes(finishDate.getMinutes() + 59);
      finishDate.setSeconds(59);

      const startTime = startDate.toISOString();
      const finishTime = finishDate.toISOString();

      const courtId = seat.bitrixCourtId || seat.courtId?.toString() || '';

      if (!courtId) {
        console.warn(`Missing courtId for seat ${key}`);
        return;
      }

      result.push({
        startTime,
        finishTime,
        courtId,
      });
    } catch (error) {
      console.error(`Error processing seat ${key}:`, error);
    }
  });

  return result;
}
